import { Box } from '@mui/material';

import { FicFidcCompositionCard } from './FicFidcCompositionCard';
import { useFollowingViewContext } from '../../../Wallet/FollowingView/FollowingViewContext';
import { useFicFidcCockpitConcentration } from '../concentration/useFicFidcCockpitConcentration';

export function FicFidcAssetConcentrationChart() {
  const { operationId, indicatorsCompetencyDate } = useFollowingViewContext();
  const { status, data } = useFicFidcCockpitConcentration(
    operationId,
    indicatorsCompetencyDate,
  );
  const fallbackData = {
    key: 'asset' as const,
    label: 'Ativo-lastro',
    amount: null,
    percentage: null,
    status: status === 'error' ? ('error' as const) : ('unavailable' as const),
    reason:
      status === 'error'
        ? ('source-error' as const)
        : ('missing-metadata' as const),
    competence: null,
    coverage: { total: 0, withMetadata: 0 },
    items: [],
  };

  return (
    <Box
      id="fic-fidc-asset-concentration-chart"
      aria-label="Concentração por ativo-lastro"
      sx={{ minWidth: 0 }}>
      <FicFidcCompositionCard
        data={data?.composition.asset ?? fallbackData}
        loading={status === 'loading'}
        testId="fic-fidc-asset-concentration-card"
      />
    </Box>
  );
}
